import React from 'react';
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import FeaturesSection from './components/FeaturesSection';
import SocialProof from './components/SocialProof';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsOfServicePage from './components/TermsOfServicePage';

function App() {
  const [route, setRoute] = useState<string>(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setRoute(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const isPrivacy = route === '/privacy';
  const isTerms = route === '/terms';
  const isMainPage = !isPrivacy && !isTerms;

  const closeModal = () => {
    window.history.pushState({}, '', '/');
    setRoute('/');
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {isMainPage && (
        <>
          <Header />
          <Hero />
          <ProblemSection />
          <FeaturesSection />
          <SocialProof />
          <FinalCTA />
          <Footer />
        </>
      )}

      {isPrivacy && (
        <div>
          <Header />
          <PrivacyPolicyPage isOpen={true} onClose={closeModal} />
          <Footer />
        </div>
      )}

      {isTerms && (
        <div>
          <Header />
          <TermsOfServicePage isOpen={true} onClose={closeModal} />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
